import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import googleIcon from "../../assets/img/google-icon.svg";
import axios from "axios";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import Modal from "../modal/Modal";
import { Icon } from "@iconify/react/dist/iconify.js";
import confirmIcon from "../../assets/img/iconamoon--shield-yes-fill.svg";
import Cookies from "js-cookie";
const SignupForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [nameError, setNameError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [emailError, setEmailError] = useState("");
  const [generalError, setGeneralError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [sectors, setSectors] = useState([]);
  const [sites, setSites] = useState([]);
  const [locationError, setLocationError] = useState(null);
  const [selectedProvince, setSelectedProvince] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedSector, setSelectedSector] = useState("");

  const baseUrl = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const googleEmail = queryParams.get("email");
    const googleName = queryParams.get("name");

    if (googleEmail) setEmail(googleEmail);
    if (googleName) setName(googleName);
  }, [location.search]);

  useEffect(() => {
    let timer;
    if (showConfirmationModal) {
      timer = setTimeout(() => {
        handleCloseConfirmationModal();
      }, 5000);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [showConfirmationModal]);

  useEffect(() => {
    const fetchSites = async () => {
      try {
        const token = Cookies.get("token");
        const response = await axios.get(`${baseUrl}/api/sites`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const sitesData = response.data;
        setSites(sitesData);

        const uniqueProvinces = [
          ...new Set(sitesData.map((site) => site.province)),
        ].sort();
        const uniqueDistricts = [
          ...new Set(sitesData.map((site) => site.district)),
        ].sort();
        const uniqueSectors = [
          ...new Set(
            sitesData
              .map((site) => site.sector)
              .filter((sector) => sector !== null)
          ),
        ].sort();

        setProvinces(uniqueProvinces);
        setDistricts(uniqueDistricts);
        setSectors(uniqueSectors);
      } catch (error) {
        setGeneralError("Failed to load location data");
      }
    };

    if (role === "SCANNER_ASSISTANT") {
      fetchSites();
    } else {
      setProvinces([]);
      setDistricts([]);
      setSectors([]);
      setSites([]);
      setSelectedProvince("");
      setSelectedDistrict("");
      setSelectedSector("");
      setLocationError(null);
    }
  }, [baseUrl, role]);

  const validateForm = () => {
    let isValid = true;
    setNameError("");
    setEmailError("");
    setGeneralError("");

    if (!name) {
      setNameError("Name is required");
      isValid = false;
    }

    if (!email) {
      setEmailError("Email is required");
      isValid = false;
    }

    if (
      role === "SCANNER_ASSISTANT" &&
      (!selectedProvince || !selectedDistrict)
    ) {
      setLocationError(
        "Province and district are required for Scanner Assistant"
      );
      isValid = false;
    }

    return isValid;
  };

  const handleCloseConfirmationModal = () => {
    setShowConfirmationModal(false);
    navigate("/login");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "name") {
      setName(value);
    } else if (name === "email") {
      setEmail(value);
    } else if (name === "role") {
      setRole(value);
      setSelectedProvince("");
      setSelectedDistrict("");
      setSelectedSector("");
    } else if (name === "province") {
      setSelectedProvince(value);
      setSelectedDistrict("");
      setSelectedSector("");
    } else if (name === "district") {
      setSelectedDistrict(value);
      setSelectedSector("");
    } else if (name === "sector") {
      setSelectedSector(value);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);

    if (!validateForm()) {
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(`${baseUrl}/api/users/request`, {
        name,
        email,
        role,
        ...(role === "SCANNER_ASSISTANT" && {
          province: selectedProvince,
          district: selectedDistrict,
          ...(selectedSector && { sector: selectedSector }),
        }),
      });
      if (res.status === 201) {
        setSuccessMessage("Signup successful!");
        setName("");
        setEmail("");
        setRole("");
        setSelectedProvince("");
        setSelectedDistrict("");
        setSelectedSector("");
        setShowConfirmationModal(true);
      } else {
        setGeneralError("Signup failed. Please try again.");
      }
    } catch (err) {
      if (err.response) {
        if (
          err.response.status === 400 &&
          err.response.data.error === "A request for this email already exists"
        ) {
          setGeneralError("An account request for this email already exists.");
        } else {
          setGeneralError(err.response.data.error);
        }
      } else if (err.request) {
        setGeneralError("Server is not responding. Please try again later");
      } else {
        setGeneralError("An error occurred. Please try again");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleSignup = () => {
    const url = `${baseUrl}/api/users/auth/google`;
    window.location.href = url;
  };
  return (
    <>
      <div className="login-grid-container">
        <div className="second-grid-container">
          <div className="second-grid-column">
            {/* <div className="img-container">
              <img src={loginFrame} alt="illustration" />
            </div> */}
            <div className="welcome-message">Welcome to!</div>
            <div className="logo-name title">
              <span>MonitorPro</span>
            </div>
            <div className="description">
              Track your project's journey with precision and clarity. Monitor
              Pro empowers teams to achieve goals efficiently. Stay connected,
              informed, and in control.
            </div>
          </div>
          <div className="privacy-policy">
            <a href="#">Privacy Policy</a>
            <a href="#">Terms & Conditions</a>
          </div>
        </div>
        <div className="first-grid-container register">
          <div className="logo-name">
            <span>MonitorPro</span>
          </div>
          <div className="first-grid-column">
            <div className="title staff">Staff Area</div>

            {/* <div className="welcome">Hi, Welcome 👋 </div> */}
            {/* <div className="login-text-container">
              <div className="line"></div>
              <div className="login-text">or Login with Email</div>
              <div className="line"></div>
            </div> */}
            <div className="login-form">
              <form onSubmit={handleRegister}>
                <div className="account">
                  <input
                    name="name"
                    type="text"
                    placeholder="Name"
                    value={name}
                    onChange={handleChange}
                  />
                  {isSubmitted && nameError && (
                    <div className="error-message">{nameError}</div>
                  )}
                </div>
                <div className="password">
                  <input
                    name="email"
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={handleChange}
                  />
                  {isSubmitted && emailError && (
                    <div className="error-message">{emailError}</div>
                  )}
                </div>
                <div className="account select">
                  <select
                    name="role"
                    id="role"
                    value={role}
                    onChange={handleChange}
                  >
                    <option value="" disabled>
                      Select Role
                    </option>
                    <option value="DATA_ENTRY_CLERK">Data Entry Clerk</option>
                    <option value="SCANNER_OPERATOR">Scanner Operator</option>
                    <option value="SCANNER_ASSISTANT">Scanner Assistant</option>
                  </select>
                  <Icon
                    icon="icon-park:down"
                    className="carret-down"
                    color="var(--menu-color)"
                  />
                </div>
                {role === "SCANNER_ASSISTANT" && (
                  <>
                    <div className="account select">
                      <select
                        name="province"
                        id="province"
                        value={selectedProvince}
                        onChange={handleChange}
                      >
                        <option value="" disabled>
                          Select Province
                        </option>
                        {provinces.map((province) => (
                          <option key={province} value={province}>
                            {province}
                          </option>
                        ))}
                      </select>
                      <Icon
                        icon="icon-park:down"
                        className="carret-down"
                        color="var(--menu-color)"
                      />
                    </div>
                    <div className="account select">
                      <select
                        name="district"
                        id="district"
                        value={selectedDistrict}
                        onChange={handleChange}
                        disabled={!selectedProvince}
                      >
                        <option value="" disabled>
                          Select District
                        </option>
                        {districts
                          .filter((district) =>
                            sites.some(
                              (site) =>
                                site.province === selectedProvince &&
                                site.district === district
                            )
                          )
                          .map((district) => (
                            <option key={district} value={district}>
                              {district}
                            </option>
                          ))}
                      </select>
                      <Icon
                        icon="icon-park:down"
                        className="carret-down"
                        color="var(--menu-color)"
                      />
                    </div>
                    <div className="account select">
                      <select
                        name="sector"
                        id="sector"
                        value={selectedSector}
                        onChange={handleChange}
                        disabled={!selectedDistrict}
                      >
                        <option value="" disabled>
                          Select Sector (Optional)
                        </option>
                        {sectors
                          .filter((sector) =>
                            sites.some(
                              (site) =>
                                site.province === selectedProvince &&
                                site.district === selectedDistrict &&
                                site.sector === sector
                            )
                          )
                          .map((sector) => (
                            <option key={sector} value={sector}>
                              {sector}
                            </option>
                          ))}
                      </select>
                      <Icon
                        icon="icon-park:down"
                        className="carret-down"
                        color="var(--menu-color)"
                      />
                    </div>
                    {isSubmitted && locationError && (
                      <div className="error-message">{locationError}</div>
                    )}
                  </>
                )}

                {generalError && (
                  <div className="error-message">{generalError}</div>
                )}
              </form>
              <div className="button-group signup">
                <button
                  type="submit"
                  className={`login-btn ${loading ? "btn-disabled" : ""} `}
                  disabled={loading}
                  onClick={handleRegister}
                >
                  {loading ? (
                    <AiOutlineLoading3Quarters className="loader" />
                  ) : (
                    "Register"
                  )}
                </button>
                <div className="google-btn">
                  <button
                    type="button"
                    className={`google-login-btn ${
                      loading ? "btn-disabled" : ""
                    } `}
                    disabled={loading}
                    onClick={handleGoogleSignup}
                  >
                    <img
                      src={googleIcon}
                      alt="google"
                      className="google-icon"
                    />
                    Sign up with Google
                  </button>
                </div>
              </div>
              <div className="back-office registered">
                <p>Already registered?</p>
                <a href="/login">Sign In</a>
              </div>
            </div>
          </div>
          <div className="copyright">
            © {new Date().getFullYear()} - AzulPlan. All rights reserved.
          </div>
        </div>

        <Modal
          show={showConfirmationModal}
          onClose={handleCloseConfirmationModal}
        >
          <div className="content confirmation">
            <div className="icon-container">
              <img
                src={confirmIcon}
                alt="confirm"
                width="57"
                height="57"
                style={{ color: "#007011" }}
              />
            </div>
            <div className="text">
              You have successfully submitted your registration request! Once
              approved, you will receive an email.
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default SignupForm;
